import { PlusOutlined } from '@ant-design/icons';
import { Button, ContentFilters, ContentTopBar } from 'components';
import { AddAdminUserModal } from 'features/users/components/modals/add-admin-user-modal';
import { UserFilterFormsValues } from 'features/users/components/users-filter-form/types';
import { UsersFilterForm } from 'features/users/components/users-filter-form/users-filter-form';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

type UserProps = {
  showAddUserModal: boolean; // `showAddUserModal` should be a boolean since it's likely used to control modal visibility
  setShowAddUserModal: React.Dispatch<React.SetStateAction<boolean>>; // Function to toggle the modal state
  handleFilter: (values: UserFilterFormsValues) => void;
  getInitialFilterValues: UserFilterFormsValues;
};
export const UsersTopBar = ({
  showAddUserModal,
  setShowAddUserModal,
  handleFilter,
  getInitialFilterValues,
}: UserProps) => {
  useState<any>();
  const { t } = useTranslation();
  const formId = 'users-filters-form';

  return (
    <>
      <ContentTopBar
        title={t('usermanagement.heading')}
        renderButtons={
          <>
            <Button
              className='btn btn-primary w-full text-center justify-center !p-2'
              type='primary'
              icon={<PlusOutlined />}
              onClick={() => setShowAddUserModal(true)}
            >
              {t('usermanagement.button.adduser')}
            </Button>
            {showAddUserModal && (
              <AddAdminUserModal onClose={() => setShowAddUserModal(false)} />
            )}
          </>
        }
      />
      <ContentFilters formId={formId}>
        <UsersFilterForm
          formId={formId}
          handleFilter={handleFilter}
          initialValues={getInitialFilterValues}
        />
      </ContentFilters>
    </>
  );
};
